import { create } from 'zustand';
import { UserPreferenceStoreType } from './types';
import { getUserPreferenceFromLocalStorage } from './utils';

export const preferenceStore = create<UserPreferenceStoreType>()((set) => ({
  preference: undefined,
  initialise: () => {
    try {
      const preference = getUserPreferenceFromLocalStorage();
      if (preference) {
        set({ preference });
      }
    } catch (error: any) {
      console.error('Error:: Fetching the preference ::', error);
    }
  },
  setPreferenece: (preference) => set({ preference }),
}));

preferenceStore.getState().initialise();
